import { Icon } from "@iconify/react";
import Modal from "../UI/Modal";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { closeViewModal } from "../../store/reducers/schools/schools.reducer";
import Loader from "../UI/Loader";
import Field from "../UI/Field";
import AuditInfo from "../UI/AuditInfo";

const SchoolViewModal = () => {
  const dispatch = useDispatch();

  const {
    viewModalOpen,
    selectedSchool,
    selectedSchoolLoading,
    selectedSchoolError,
  } = useSelector((state) => state.schools);

  const handleClose = () => {
    dispatch(closeViewModal());
  };

  return (
    <Modal
      open={viewModalOpen}
      onClose={handleClose}
      title="Detalle de la escuela"
      size="xl"
    >
      {selectedSchoolLoading ? (
        <div className="text-center py-5">
          <Loader type="spinner" size="lg" delay={0} />
        </div>
      ) : selectedSchoolError ? (
        <div className="text-center py-5">
          <Icon icon="mdi:alert-circle" width="48" height="48" className="text-muted" />
          <p className="text-muted mt-3">{selectedSchoolError}</p>
        </div>
      ) : selectedSchool ? (
        <div className="row g-4">
          {/* Columna Izquierda */}
          <div className="col-md-6">
            <div className="d-flex flex-column gap-3">
              <Field
                icon="mdi:school-outline"
                label="Nombre"
                value={selectedSchool.nombre}
              />
              <Field
                icon="mdi:alphabetical"
                label="Siglas"
                value={selectedSchool.siglas}
              />
            </div>
          </div>

          {/* Columna Derecha */}
          <div className="col-md-6">
            <div className="d-flex flex-column gap-3">
              <Field
                icon="mdi:format-list-bulleted-type"
                label="Tipo"
                value={selectedSchool.tipo}
              />
              <Field
                icon="mdi:office-building-outline"
                label="Modalidad"
                value={selectedSchool.publica ? "Pública" : "Privada"}
              />
              <Field
                icon="mdi:account-group-outline"
                label="Público objetivo"
                value={
                  selectedSchool.para_publico_en_general ? (
                    <span className="badge bg-info-subtle text-info">
                      <Icon icon="mdi:earth" width="14" height="14" className="me-1" />
                      Público en general
                    </span>
                  ) : (
                    <span className="badge bg-warning-subtle text-warning">
                      <Icon icon="mdi:account-group" width="14" height="14" className="me-1" />
                      Grupo específico
                    </span>
                  )
                }
              />
              <Field
                icon="mdi:toggle-switch"
                label="Estado"
                value={
                  selectedSchool.is_active ? (
                    <span className="badge bg-success-subtle text-success">
                      <Icon
                        icon="mdi:check-circle"
                        width="14"
                        height="14"
                        className="me-1"
                      />
                      Activo
                    </span>
                  ) : (
                    <span className="badge bg-danger-subtle text-danger">
                      <Icon
                        icon="mdi:close-circle"
                        width="14"
                        height="14"
                        className="me-1"
                      />
                      Inactivo
                    </span>
                  )
                }
              />
            </div>
          </div>

          {/* Información de auditoría */}
          <div className="col-12">
            <AuditInfo
              createdAt={selectedSchool.created_at}
              updatedAt={selectedSchool.updated_at}
              createdBy={selectedSchool.created_by}
              updatedBy={selectedSchool.updated_by}
            />
          </div>
        </div>
      ) : (
        <div className="text-center py-5">
          <Icon icon="mdi:alert-circle" width="48" height="48" className="text-muted" />
          <p className="text-muted mt-3">No se pudo cargar la información</p>
        </div>
      )}
    </Modal>
  );
};

export default SchoolViewModal;
